<template>
  <div class="d-flex justify-space-between">
    <GradeClassStudentSelect
      disableGradeSelect
      @changed="gradeClassStudentChange"
      :studentCol="{ cols: 6, sm: 6, md: 6 }"
      :classCol="{ cols: 6, sm: 6, md: 6 }"
    />
    <v-btn class="search-button" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
  </div>
</template>
<script>
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import { mapActions } from 'vuex'
export default {
  components: { GradeClassStudentSelect },
  data: () => ({ student: null, class: null }),
  methods: {
    ...mapActions({ search: 'studentSurvey/search' }),
    gradeClassStudentChange(val) {
      this.student = val.student
      this.class = val.class
    },
    async onFilterChanged() {
      const params = { survey: this.$route.params.id, _sort: 'sortKey:ASC' }

      if (this.student) params['student'] = this.student.id
      if (this.class) params['class'] = this.class.id

      await this.search(params)
    }
  }
}
</script>